import { createOutlineIcon } from "../createIcon";

export const ListOutlineIcon = createOutlineIcon(
  <>
    <path d="M8.71998 6H21.6M8.71998 12.48H21.6M8.71998 18.96H21.6M3.59998 6V6.0128M3.59998 12.48V12.4928M3.59998 18.96V18.9728" />
  </>,
  "ListOutlineIcon"
);
